import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import {Fragment, useState} from 'react'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'
import {AmazonLogoLetterIcon} from '~/icons/amazon-logo-letter-icon'
import {IconChevronRight} from '~/icons/brg-icon-chevron-right'
import {FreeDeliveryIcon} from '~/icons/free-delivery-icon'
import {ReturnProcessIcon} from '~/icons/return-process-icon'
import {VerifiedReviewsIcon} from '~/icons/verified-reviews-icon'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {getDailyNumber} from '~/utils/commons'

const iconsById = {
  freeDelivery: () => <FreeDeliveryIcon />,
  easyReturns: () => <ReturnProcessIcon />,
  verifiedReviews: () => <VerifiedReviewsIcon />,
} as Record<string, () => JSX.Element>

const WhyAmazonEUSection = () => {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const [isRankSectionOpen, setIsRankSectionOpen] = useState(false)

  const reportClick = useReportWidgetClick()

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'rank-section-eu',
    widget_place: 'middle',
  })

  return (
    <div className="flex flex-col gap-3" ref={widgetRef}>
      <button
        type="button"
        onClick={() => {
          setIsRankSectionOpen(!isRankSectionOpen)
          reportClick({
            widget_name: 'rank-section-eu',
            widget_place: 'middle',
            trigger_type: isRankSectionOpen ? 'expand-button-close' : 'expand-button-open',
          })
        }}
        aria-label="expand-rank-section"
        className="relative z-20 flex h-full w-full flex-row items-center justify-center gap-2 overflow-hidden rounded-2xl bg-amber-200 px-4 py-3 text-center text-base font-normal transition-all duration-200 ease-in-out tablet:justify-start [&>.star]:size-7 [&>.star]:fill-amber-300/60"
      >
        <AmazonLogoLetterIcon className="size-5" />
        {translations.WhyAmazonSection.title}
        <IconChevronRight
          fill="black"
          className={clsx(
            'ml-7 size-5 transition-all duration-200 ease-in-out tablet:ml-auto',
            isRankSectionOpen ? '-rotate-90' : 'rotate-90',
          )}
        />
      </button>
      {isRankSectionOpen ? (
        <div className="mx-auto w-full overflow-hidden">
          <div className="flex flex-col gap-3 rounded-xl bg-amber-200 px-8 py-4 tablet:px-3 tablet:py-3">
            <div className="flex flex-row justify-between gap-2 tablet:flex-col">
              {translations.WhyAmazonSection.specs.map((spec) => (
                <Fragment key={spec.id}>
                  <div className="flex w-full flex-row items-center gap-3 rounded-xl bg-white p-3">
                    {iconsById[spec.id]()}
                    <div className="flex flex-col">
                      <span className="text-base text-gray-900">{spec.label}</span>
                      <span className="text-sm text-gray-500">{spec.description}</span>
                    </div>
                  </div>
                </Fragment>
              ))}
            </div>
            <span className="self-center text-base font-light text-amber-800">
              <b className="font-medium">{translations.WhyAmazonSection.dealsCount(getDailyNumber())}</b>
              {translations.WhyAmazonSection.dealsMade}
            </span>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default WhyAmazonEUSection
